import React, { ReactComponentElement, useMemo, useState } from 'react'
import { Card } from 'reactstrap'
import withCustomization from 'components/platform/hocs/withCustomization'
import { TabsCardBody, TabsCardHeader } from 'components/platform/Pages/CustomizableTabs'
import { SettingsButton } from 'components/platform/app/Buttons'
import { FormattedMessage } from 'react-intl'

export interface FormFieldsProps {
  className?: string
  sortedFields: any[]
  renders: { [key: string]: ReactComponentElement<any> }
}

export const FormFields = ({ sortedFields, renders, className = 'fg-2e' }: FormFieldsProps) => {
  return useMemo(() => {
    return (
      <div style={{ padding: 10 }} className={`fg ${className}`}>
        {sortedFields.map(field => renders[field.name])}
      </div>
    )
  }, [className, renders, sortedFields])
}

// @ts-ignore
export const CustomizableFields = withCustomization({
  prefix: 'form',
  renderLabelProp: 'label',
  modalTitle: 'global.fields',
})(FormFields)

export interface CustomizableFormProps {
  titlekey: string
  customizationName?: string
  defaultItems: any[]
  renders: { [key: string]: ReactComponentElement<any> }
  className?: string
  icon?: any
  append?: any
  buttonSaveAreaP?: any
}

export const CustomizableCardForm = ({
  titlekey,
  customizationName,
  defaultItems,
  icon,
  append,
  buttonSaveAreaP,
  ...props
}: CustomizableFormProps) => {
  const [opened, setOpened] = useState(false)
  // const {definitions} = useContext(CustomizableTabsContext);
  const editable = !!customizationName
  const title = titlekey && <FormattedMessage id={titlekey} />
  return (
    <Card>
      <TabsCardHeader
        title={title}
        icon={icon}
        append={append}
        /*
        // @ts-ignore     */
        note
        /*
        // @ts-ignore     */
        right={
          <div style={{ display: 'flex' }}>
            <div className={'mr-3'}>{buttonSaveAreaP && <div>{buttonSaveAreaP}</div>}</div>
            <div>
              {editable && (
                <SettingsButton
                  onClick={() => setOpened(true)}
                  labelKey={'global.customize_fields'}
                />
              )}
            </div>
          </div>
        }
      />
      <TabsCardBody>
        {editable ? (
          <CustomizableFields
            onCustomizationClose={() => setOpened(false)}
            customizationOpened={opened}
            customizationName={customizationName}
            definitions={defaultItems}
            {...props}
          />
        ) : (
          <FormFields sortedFields={defaultItems} {...props} />
        )}
      </TabsCardBody>
    </Card>
  )
}

// renamed
export const CustomizableForm = CustomizableCardForm
